import { createElement, Fragment } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
const TEMPLATE = [['core/paragraph', {
  placeholder: __('Add text or blocks that will display when the query returns no results.')
}]];
export default function QueryNoResultsEdit() {
  const blockProps = useBlockProps();
  const innerBlocksProps = useInnerBlocksProps(blockProps, {
    template: TEMPLATE
  });
  return createElement(Fragment, null, createElement("div", innerBlocksProps));
}
//# sourceMappingURL=edit.js.map